/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_BundeslandInputs */

const de__field_bundesland = /** @type {(inputs: _Field_BundeslandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundesland`)
};

/**

* @param {_Field_BundeslandInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_bundesland = /** @type {((inputs?: _Field_BundeslandInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_BundeslandInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_bundesland(inputs)
});